import React, { useEffect, useState } from 'react';
import CandidateAppManager from "../StatCounter/CandidateAppManager";

const AppModal = ({ toggle, showTitle }) => {
  return (
    <>
      <div
        id="appModal"
        className="modal fade modal-wanderly-chat profile-modal in"
        tabIndex="-1"
        role="dialog"
        aria-labelledby="appModallLabel"
        data-keyboard="false"
        data-backdrop="static"
        style={{ display: 'block' }}
      >
        <div className="modal-dialog" role="document">

          <div className="modal-content wanderly-app-section">
            <div className="modal-header">
              <h2 className="font-weight-bold text-center">Download Wanderly App</h2>
              <button
                type="button"
                className="glyphicon glyphicon-remove close"
                onClick={toggle}
              ></button>
            </div>
            <div className="modal-body " style={{ margin: 0, background: 'transparent', minHeight: '300px' }}>
              <div className="row">
                <div className="col-12 pt-sm-3 ps-sm-3 pe-sm-5" style={{
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  flexDirection: 'column'
                }}>
                  <CandidateAppManager showTitle={showTitle} isModal={true} />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="modal-backdrop fade in"></div>
    </>
  );
};

export default AppModal;
